// extracted by mini-css-extract-plugin
export default {"grid":"mtdhd7aZZM0yXb7AcYAw"};